import { all } from './util';

(() => {

    const buttonListener = (b: HTMLButtonElement) => {
        if (b.getAttribute('type') === 'submit') {
            if (b.getAttribute('data-disable') === 'false') {
                // don't disable the button if it has a value set. disabled buttons won't post their value!
            } else {
                b.setAttribute('disabled', 'true');
            }
        }
    }

    all<HTMLFormElement>('form').forEach(f => {
        f.addEventListener('submit', () => {
            all<HTMLButtonElement>('button', f).forEach(b => buttonListener(b));
        });
    });
})()